<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Contents</h1>
</div>
</div>
<blockquote>
<p class="first">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Introduction</span></p>
</blockquote>
<blockquote>
<p class="first">
		PART ONE: The Job</p>
<p class="toc">
		1. Putting it in the Newspaper</p>
<p class="toc">
		2. Never Too Young, Never Too Old</p>
<p class="toc">
		3. Love Kills</p>
<p class="toc">
		4. The Twilight Zone</p>
<p class="toc">
		5. Better than Real Life</p>
<p class="first">
		SIDEBAR: Romance</p>
</blockquote>
<blockquote>
<p class="first">
		PART TWO: The City</p>
<p class="toc">
		6. Home, Sweet Home</p>
<p class="toc">
		7. Miami, Old and New</p>
<p class="toc">
		8. Christmas in Miami</p>
<p class="toc">
		9. Best Freinds</p>
<p class="first">
		SIDEBAR: Duck</p>
</blockquote>
<blockquote>
<p class="first">
		PART THREE: The Heroes</p>
<p class="toc">
		10. Fire!</p>
<p class="toc">
		11. Water</p>
<p class="toc">
		12. Street Cops</p>
<p class="toc">
		13. Shot Cops</p>
<p class="toc">
		14. Heroes</p>
<p class="first">
		SIDEBAR: No Hero</p>
</blockquote>
<blockquote>
<p class="first">
		PART FOUR: The Storeis</p>
<p class="toc">
		15. Lorri</p>
<p class="toc">
		16. Lawyers and Judges</p>
<p class="toc">
		17. Mrs. Z</p>
<p class="toc">
		18. Amy</p>
<p class="toc">
		19. Courage</p>
<p class="toc">
		20. A New Chapter</p>
</blockquote>
<blockquote>
<p class="first">
		Acknowledgments</p>
<p class="first">
		About the Author</p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0425138240_08_toc.vue?069c7319